import React from 'react';
import styled from 'styled-components';
import WarningIcon from '@mui/icons-material/Warning';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { PALETTE, TYPOGRAPHY } from '~/assets/styles/base';

const StyledBox = styled.div`
  background: ${PALETTE.white};
  width: 720px;
  border: 1px solid ${PALETTE.border.frame};
  margin: 111px auto;
  padding: 55px 20px;
  text-align: center;
  white-space: pre-line;
  a {
    text-decoration: none;
  }
`;

const FlexStyle = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

const StyledWarningImg = styled(WarningIcon)`
  color: ${PALETTE.error.main};
  font-size: 125px;
  margin: 0 40px;
`;

const StyledTextWrapper = styled.div`
  text-align: left;
`;

const NotFoundError = (): JSX.Element => {
  const { t } = useTranslation();
  return (
    <StyledBox>
      <FlexStyle>
        <StyledWarningImg />
        <StyledTextWrapper>
          <Typography sx={{ fontSize: '24px' }} data-testid="PagesErrorTitle">
            {t('error.title')}
          </Typography>
          <br />
          <Typography sx={{ fontSize: TYPOGRAPHY.bodyDefault }} data-testid="PagesErrorMessage">
            {t('error.404.message')}
          </Typography>
        </StyledTextWrapper>
      </FlexStyle>
    </StyledBox>
  );
};

export default NotFoundError;
